import { render, staticRenderFns } from "./TheHeaderDropdownNoti.vue?vue&type=template&id=dd8a8120&scoped=true"
import script from "./TheHeaderDropdownNoti.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownNoti.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownNoti.vue?vue&type=style&index=0&id=dd8a8120&prod&lang=css"
import style1 from "./TheHeaderDropdownNoti.vue?vue&type=style&index=1&id=dd8a8120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8a8120",
  null
  
)

export default component.exports